import React, { FC } from 'react';
import { Box, Checkbox, Text } from '@bechtel/gds';
import { FieldArray, FieldProps } from 'formik';
import { findIndex, some, map } from 'lodash';
import { ListSelectionStyled, DrawerSubHeaderStyled, SubListSelectionStyled } from '@bechtel/client-common';
import { Trans } from '@lingui/macro';
import { pickupTimeList } from '../form-state';
import { useLingui } from '@lingui/react';

export const PickupTimeList: FC<FieldProps> = ({ form }) => {
  const { i18n } = useLingui();

  return (
    <Box flexDirection={{ sm: 'column' }} data-testid="pickup-time-container">
      <DrawerSubHeaderStyled>
        <Trans>Pickup Time</Trans>
      </DrawerSubHeaderStyled>
      <SubListSelectionStyled
        data-testid="pickup-time-all"
        onClick={() => {
          if (form.values.pickupTimeList?.length !== pickupTimeList.length) {
            form.setFieldValue('pickupTimeList', map(pickupTimeList, 'value'));
          } else {
            form.setFieldValue('pickupTimeList', []);
          }
        }}
      >
        <Box alignItems={{ sm: 'center' }}>
          <Box mr={{ sm: '500' }}>
            <Checkbox
              checked={form.values.pickupTimeList?.length === pickupTimeList.length}
              indeterminate={
                form.values.pickupTimeList?.length > 0 && form.values.pickupTimeList?.length < pickupTimeList.length
              }
              readOnly
            />
          </Box>
          <Text size="400" weight="600" color="bechtel.grey.1000">
            <Trans>Select All</Trans>
          </Text>
        </Box>
        {form.values.pickupTimeList && form.values.pickupTimeList.length > 0 && (
          <Text size="400" color="bechtel.grey.1000" data-testid="pickup-time-selected-length">
            {form.values.pickupTimeList.length} <Trans>Selected</Trans>
          </Text>
        )}
      </SubListSelectionStyled>
      <FieldArray name="pickupTimeList">
        {(arrayHelpers) => {
          return (
            <>
              {pickupTimeList.length > 0 &&
                pickupTimeList.map((pickupTimeItem) => {
                  return (
                    <ListSelectionStyled
                      key={pickupTimeItem.value}
                      data-testid={`pickup-time-item-${pickupTimeItem.value}`}
                      onClick={() => {
                        const selected = findIndex(form.values.pickupTimeList, (item) => {
                          return item === pickupTimeItem.value;
                        });
                        if (selected !== -1) {
                          arrayHelpers.remove(selected);
                        } else {
                          arrayHelpers.push(pickupTimeItem.value);
                        }
                      }}
                    >
                      <Box mr={{ sm: '500' }}>
                        <Checkbox
                          checked={some(form.values.pickupTimeList, (item) => {
                            return item === pickupTimeItem.value;
                          })}
                          readOnly
                        />
                      </Box>
                      <Text size="400" color="bechtel.grey.1000">
                        {i18n._(pickupTimeItem.label)}
                      </Text>
                    </ListSelectionStyled>
                  );
                })}
            </>
          );
        }}
      </FieldArray>
    </Box>
  );
};
